import { svg } from "lit";
const icon = svg `<path d="M6.57499 19.9618L8.00767 13.7926L3.22119 9.6446L9.53652 9.09655L11.9999 3.2793L14.4634 9.09655L20.7787 9.6446L15.9922 13.7926L17.4249 19.9618L11.9999 16.6888L6.57499 19.9618Z" fill="currentColor"/>`;
export default icon;
